import Cookies from "js-cookie";
// import { useAuth } from "../Context/AuthProvider";
import { customDecrypt, decrypt, key } from "./EncryptionDescryption";

var ciphertext = Cookies.get(
  "YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD"
);
var decryptredTextED = decrypt(ciphertext, key);
export const checkPermissions = (page) => {
  let ciphertext = localStorage.getItem("sdh4AAhdsgsjd660-sd");
  var decryptredText = customDecrypt(ciphertext, key);
  let data = JSON.parse(decryptredText);

  for (let i = 0; i < data.length; i++) {
    const val = data[i];
    if (
      val.page_name === page &&
      (val.read_only === 1 || val.read_and_write === 1)
    ) {
      return true; // Dashboard access found with required permissions
    }
  }
  return false; // Dashboard access not found with required permissions
};

export const determineAllowedRoute = () => {
  if (decryptredTextED[1][1] === "3") {
    let ciphertext = localStorage.getItem("sdh4AAhdsgsjd660-sd");
    var decryptredText = customDecrypt(ciphertext, key);
    var userData = JSON.parse(decryptredText);
    const allowedPages = ["dashboard", "call-records", "vpbx-manager"];
    let allowedRoute = "notFound";

    // Iterate through each object in the userData array
    for (const page of userData) {
      // Check if the page_name is one of the allowedPages
      if (allowedPages.includes(page.page_name)) {
        // Check if either read_and_write or read_only is 1
        if (page.read_and_write === 1 || page.read_only === 1) {
          // Store the route of the first page found
          allowedRoute = page.page_name;
          break; // Exit loop once a valid page is found
        }
      }
    }

    return allowedRoute;
  }
};

export const checkIndividualPermission = (page, permission) => {
  if (decryptredTextED[1][1] === "3") {
    let ciphertext = localStorage.getItem("sdh4AAhdsgsjd660-sd");
    var decryptredText = customDecrypt(ciphertext, key);
    let data = JSON.parse(decryptredText);

    for (let i = 0; i < data.length; i++) {
      const val = data[i];
      if (val.page_name === page && val[permission] === 1) {
        return true; // Dashboard access found with required permissions
      }
    }
    return false; // Dashboard access not found with required permissions
  }
};
